export default __webpack_public_path__ + "static/media/RightArrowLight.deff93ac.svg";